import { Animated, Easing } from 'react-native';

export const incorrectAnimation = (x) =>
  Animated.loop(
    Animated.sequence([
      Animated.timing(x, {
        toValue: -1,
        duration: 50,
        easing: Easing.out(Easing.linear),
        useNativeDriver: true,
      }),
      Animated.timing(x, {
        toValue: 1,
        duration: 100,
        easing: Easing.out(Easing.linear),
        useNativeDriver: true,
      }),
      Animated.timing(x, {
        toValue: 0,
        duration: 50,
        easing: Easing.out(Easing.linear),
        useNativeDriver: true,
      }),
    ]),
    {
      iterations: 2,
    }
  );

const zoomInAndOut = (scale) =>
  Animated.sequence([
    Animated.timing(scale, {
      toValue: 1,
      duration: 100,
      delay: 100,
      useNativeDriver: true,
    }),
    Animated.timing(scale, {
      toValue: 0,
      duration: 100,
      useNativeDriver: true,
    }),
  ]);

export const correctAnimation = (scale) => zoomInAndOut(scale);
